import { z } from 'zod';
import { RUNTIME_V3_POPULATION_SOURCE_CLASSES } from '../../runtime-v3/population';

const optionalText = z.string().nullable().optional();
export const savedPublicEvidenceSchema = z.object({
  kind: z.string(), id: z.string(), claim: optionalText, sourceClassLabel: optionalText,
}).strict();
const sourceComposition = z.object({
  kind: z.literal('uniform'), sourceClass: z.enum(RUNTIME_V3_POPULATION_SOURCE_CLASSES),
}).strict();
const publicMeaning = z.object({
  population: z.object({ label: z.string(), countingUnit: z.string(),
    includes: z.array(z.string()), excludes: z.array(z.string()) }).strict(),
  outputRole: z.string(), basisLabel: z.string(), sourceComposition,
}).strict();

/** The live public binding's structural wire shape; no engine re-admission or formatting. */
export const savedPublicBindingSchema = z.object({
  placeholder: z.string(), evidence: savedPublicEvidenceSchema.optional(),
  valuePath: z.string().startsWith('public.metrics.').optional(), value: z.number().optional(),
  displayValue: z.string().optional(), displayValueCompact: z.string().optional(),
  format: z.string().optional(), claimDomain: z.string().optional(), definition: z.string().optional(),
  displayLabel: optionalText, unit: z.string().optional(), meaning: publicMeaning.optional(),
  coordinates: z.record(z.string()).optional(), claimRole: z.string().optional(),
  governedDefinitionId: z.string().optional(),
  scope: z.object({ label: z.string(), entityKind: optionalText }).strict().optional(),
  timeframe: z.object({ kind: z.string(), label: z.string(), asOf: optionalText,
    start: optionalText, end: optionalText }).strict().optional(),
  source: z.object({ label: z.string(), surface: z.string(), evidenceKind: z.string(),
    asOf: optionalText, sourceRef: optionalText }).strict().optional(),
  reconciliation: z.object({ method: z.string(), rule: z.string(), total: z.number().optional(),
    presentation: z.string().optional(),
    components: z.array(z.object({ key: z.string(), label: z.string(), value: z.number(),
      role: optionalText }).strict()).nullable().optional(),
    residual: z.object({ label: z.string(), value: z.number(), unit: z.string() }).strict().nullable().optional(),
  }).strict().optional(),
  allocationMethod: optionalText, isPartial: z.boolean().optional(),
  provenance: z.object({ schemaVersion: z.string(), badge: z.string(), glyph: z.string(),
    label: z.string(), reasons: z.array(z.string()) }).strict().nullable().optional(),
}).strict();
